module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/axios/index.js
// module id = ../../node_modules/axios/index.js
// module chunks = widget-6.25.3